module.exports = [
	{
		"name": "Bay Trail (current)",
		"hex": null,
		"image": "baytrail_current.svg",
		"texture": null
	},
	{
		"name": "Bay Trail (proposed)",
		"hex": null,
		"image": "baytrail_proposed.svg",
		"texture": null
	},
	{
		"name": "Shallow Bay/Estuary/Slough",
		"hex": "#00ADEF",
		"image": null,
		"texture": "hash-mark_bg.svg"
	},
	{
		"name": "Mudflat",
		"hex": "#D9BFAD",
		"image": null,
		"texture": "circles_bg.svg"
	},
	{
		"name": "Diked Baylands",
		"hex": "#A7D1C7",
		"image": null,
		"texture": "small-triangles_bg.svg"
	},
	{
		"name": "Managed Pond",
		"hex": "#BDD6B0",
		"image": null,
		"texture": "tripod_bg.svg"
	},
	{
		"name": "Managed Marsh",
		"hex": "#83ACAA",
		"image": null,
		"texture": "small-squares_bg.svg"
	},
	{
		"name": "Tidal Marsh",
		"hex": "#9CC684",
		"image": null,
		"texture": "waves_bg.svg"
	},
	{
		"name": "Salt Pond",
		"hex": "#C0A5C4",
		"image": null,
		"texture": "small-zig-zag_bg.svg"
	},
	{
		"name": "Prohibited Zones",
		"hex": "#C27550",
		"image": null,
		"texture": "pointy-waves_bg.svg"
	},
	{
		"name": "Protected Areas",
		"hex": null,
		"image": "protected_areas.svg",
		"texture": null
	},
	{
		"name": "Shipping Channels",
		"hex": null,
		"image": "shipping_channels.svg",
		"texture": null
	}
];


//////////////////
// WEBPACK FOOTER
// ./assets/map-legend-colors.json
// module id = 461
// module chunks = 0